import { useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { AppState } from "store/types";
const useLandingPageHeaderStyles = makeStyles(() => {
  return {
    appBarBox: {
      display: "flex",
    },
    appBar: {
      maxHeight: "fit-content",
      background: "#002B49 !important",
      position: "fixed",
      padding: "0",
      "&.mobile": {
        overflowX: "auto",
        position: "absolute",
      },
    },
    toolBar: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    mainGrid: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    menuLogoHolder: {
      display: "flex",
      flexDirection: "row",
    },
    menu: {
      marginRight: "20px",
    },
    logo: {
      marginTop: "3px",
    },
    gridList: {
      paddingLeft: "5%",
    },
    list: {
      display: "flex",
      flexDirection: "row",
      padding: "10px",
    },
    demoVideo: {
      whiteSpace: "nowrap",
    },
    featuresButton: {
      paddingLeft: "0px !important",
    },
    expandLogoBox: {
      marginTop: "7px !important",
    },
    collapse: {
      position: "absolute",
      left: "0 !important",
      zIndex: 1,
      top: "60px",
      width: "max-content",
      backgroundColor: "white",
      color: "black",
      borderBottomLeftRadius: "10px",
      borderBottomRightRadius: "10px",
    },
    pricing: {
      paddingLeft: "0px !important",
    },
    drawerIcon: {
      background: "white",
      width: "240px",
    },
    drawerList: {
      background: "#002B49",
      height: "100%",
      paddingTop: "20px !important",
      display: "block !important",
    },
    expandLogo: {
      color: "white",
    },
    listItemHeaders: {
      borderBottom: "1px solid #113D5B",
    },

    listItemBackground: {
      background:
        "linear-gradient(132.91deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 99%)",
    },
    listItemFilter: {
      backdropFilter: "blur(10px)",
    },
    listItemButton: {
      minHeight: "48px !important",
      padding: "0 25px 0 25px !important",
    },
    listItemContent: {
      justifyContent: "initial",
    },
    listItemContentFalse: {
      justifyContent: "center",
    },
    listItemText: {
      fontSize: 16,
      opacity: 0,
      color: "#FFAB8C",
      "& .MuiTypography-root": {
        fontFamily: "Lato",
      },
    },
    listItemTextChinese: {
      whiteSpace: "nowrap",
    },
    listItemTextOpen: {
      opacity: 1,
    },
    listItemTextColor: {
      color: "white",
    },
    listItemButtonCollapse: {
      paddingLeft: "10px",
    },
    listItemButtonCollapseActive: {
      background:
        "linear-gradient(132.91deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 99%) !important",
      backdropFilter: "blur(10px) !important",
    },
    listItemTextCollapse: {
      color: "#FF6C37 !important",
      fontFamily: "Lato",
      "& .MuiTypography-root": {
        fontFamily: "Lato",
      },
      marginLeft: "30px",
    },
    listItemTextCollapseActive: {
      color: "white !important",
    },
    listDrawer: {
      display: "block !important",
    },
    drawerOpen: {
      "& .MuiDrawer-root .MuiDrawer-docked": {
        display: "block",
      },
      "& .MuiDrawer-paper": {
        width: "100% !important",
      },
    },

    drawerClose: {
      "& .MuiDrawer-root .MuiDrawer-docked": {
        display: "none",
      },
      "& .MuiDrawer-paper": {
        width: "0",
      },
    },
    mainPageCollapse: {
      backgroundColor: "#1976D21F !important",
    },
  };
});

export default useLandingPageHeaderStyles;
